export const messages = {
  en: {
    addAttendanceClassesStaff: {
      title: 'Add Attendance Classes Staff',
      staffName: 'Staff Name',
      staffNamePlaceholder: 'Required, please select staff',
      staffNameRequired: 'Staff name is required',
      attendanceFace: 'Attendance Face',
      submitSuccess: 'Add success',
      submitFailed: 'Add failed'
    },
    uploadImage: {
      imageSizeLimit: 'Image size cannot exceed 2MB',
      uploadFailed: 'Upload failed'
    },
    orgTree: {
      loadFailed: 'Failed to load organization tree'
    }
  },
  zh: {
    addAttendanceClassesStaff: {
      title: '添加考勤班次员工',
      staffName: '员工名称',
      staffNamePlaceholder: '必填，请选择员工',
      staffNameRequired: '员工名称不能为空',
      attendanceFace: '考勤人脸',
      submitSuccess: '添加成功',
      submitFailed: '添加失败'
    },
    uploadImage: {
      imageSizeLimit: '图片大小不能超过2MB',
      uploadFailed: '上传失败'
    },
    orgTree: {
      loadFailed: '加载组织树失败'
    }
  }
}